// UI-related constants

const SLIDER_MARK_FONT_WEIGHT = 700;

// Chart configuration
export const CHART_CONFIG = {
  WIDTH: 1000,
  HEIGHT: 300,
  STROKE_WIDTH: 2,
};

// Document titles used throughout the application
export const DOCUMENT_TITLES = {
  DASHBOARD: 'SorareAce - Dashboard',
  ALL_CARDS: 'SorareAce - All Cards',
  AUCTIONS: 'SorareAce - Active Auctions',
  MARKET: 'SorareAce - Listed Cards on the Market',
  INSTANT_BUY: 'SorareAce - Instant Buy Cards',
  MANAGER_CARDS: 'SorareAce - Manager Cards',
  TOP_PLAYERS: 'SorareAce - Top Players',
  TOP_NBA_PLAYERS: 'SorareAce - Top NBA Players',
  NBA_PLAYER: 'SorareAce - NBA Player',
  NBA_PLAYERS_LINEUP: 'SorareAce - NBA Players Lineup',
  PLAYER: 'SorareAce - Player',
  SETTINGS: 'SorareAce - Settings',
  // Dynamic titles with placeholders
  PLAYER_PROFILE: 'Player Profile - {name}',
  NBA_PLAYER_PROFILE: 'NBA Player Profile - {name}',
  NBA_LINEUP_BUILDER: 'SorareAce - NBA Lineup Builder for {manager}',
  MANAGER_CARDS_TITLE: 'Cards owned by Manager {manager}',
};

// Score threshold constants for color coding
export const SCORE_THRESHOLDS = {
  VERY_LOW: 19,
  LOW: 34,
  MEDIUM_LOW: 49,
  MEDIUM: 59,
  MEDIUM_HIGH: 74,
  HIGH: 99,
  PERFECT: 100,
};

// Range-slider bounds. Each max doubles as the "no upper bound" sentinel: when a
// filter's max equals the slider max, the user has left it unconstrained, so the
// max param is omitted from the API query (sending it would otherwise exclude
// rows above the cap and, for prices, every unpriced/unlisted row).
export const PRICE_FILTER_MIN = 0;
export const PRICE_FILTER_MAX = 2;
export const SCORE_FILTER_MIN = 0;
export const SCORE_FILTER_MAX = 100;

// Price filter marks for sliders
export const PRICE_FILTER_MARKS = {
  0: { style: { fontWeight: SLIDER_MARK_FONT_WEIGHT }, label: '0' },
  0.2: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '0.2',
  },
  0.4: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '0.4',
  },
  0.6: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '0.6',
  },
  0.8: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '0.8',
  },
  1.0: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '1.0',
  },
  1.25: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '1.25',
  },
  1.5: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '1.5',
  },
  1.75: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '1.75',
  },
  2.0: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '2.0+',
  },
};

// Played filter marks for sliders
export const PLAYED_FILTER_MARKS = {
  0: { style: { fontWeight: SLIDER_MARK_FONT_WEIGHT }, label: '0' },
  25: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '25',
  },
  50: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '50',
  },
  75: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '75',
  },
  100: {
    style: { fontWeight: SLIDER_MARK_FONT_WEIGHT },
    label: '100',
  },
};

// Flag size constants for ReactCountryFlag usage
export const FLAG_SIZES = {
  LARGE: { width: 30, height: 20 },
  MEDIUM: { width: 24, height: 16 },
  SMALL: { width: 21, height: 14 },
  TINY: { width: 18, height: 12 },
};

/** Matches decorated select rows (flag/emblem + label) for Ant Design virtual list. */
export const DECORATED_SELECT_LIST_PROPS = {
  listItemHeight: 32,
  virtual: false,
} as const;
